import { Injectable } from '@angular/core';
import { AuthSessionService } from './auth-session.service';
import { Observable, of, throwError } from 'rxjs';
import { Profiles } from '../../modules/administration/models/profiles';
import { LogService } from '../../modules/shared/services/log.service';
import { AccessDeniedService } from '../../modules/shared/services/access-denied.service';

@Injectable({
  providedIn: 'root'
})
export class UnauthenticatedUserSessionService implements AuthSessionService {

  private readonly log: LogService = new LogService(UnauthenticatedUserSessionService);

  constructor(private accessDeniedService: AccessDeniedService) {}
  
  setAccessTokenObject(accessToken: any): void {
    this.accessDeniedService.unauthenticated();
  }

  /**
   * Redirects the user to an error page, as they should not be able to use the application
   */
  configure(): Observable<void> {
    this.accessDeniedService.unauthenticated();
    return throwError(new Error('The user is unauthenticated'));
  }

  getProfiles(): Observable<Profiles> {
    this.accessDeniedService.unauthenticated();
    return throwError(new Error("The user is unauthenticated"));
  }

  getHeaders(): { [name: string]: string; } {
    this.accessDeniedService.unauthenticated();
    return {};
  }

  isReady(): Observable<boolean> {
    this.accessDeniedService.unauthenticated();
    return of(false);
  }

  logOut(): void {
    this.accessDeniedService.unauthenticated();
  }

  isSwitchable(): Observable<boolean> {
    return of(false);
  }

  logInfo(): void {
    this.log.info('======================[SESSION_INFO_BEGIN]=========================');
    this.log.info('[SESSION_TYPE]:', 'UNAUTHENTICATED_USER');
    this.log.info('The user is not properly authenticated with the application.')
    this.log.info('They should not be allowed to keep using it.')
    this.log.info('======================[SESSION_INFO_END]=========================')
  }
}
